// extracted by mini-css-extract-plugin
module.exports = {"modalContentWrapper":"modal-content_component_modalContentWrapper__qijnk","modalContentInner":"modal-content_component_modalContentInner__MNEMg"};